import React from 'react'
import PropTypes from 'prop-types'
import { InfoWindow } from '@react-google-maps/api'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { excerptTrimmer } from '../../../utils/excerpt-trimmer'
import { ExternalLink } from 'react-feather'
import { useViewport } from '../../../utils'

const MapPopupMetada = ({ data }) => {
  const language = useSelector(state => state.system.language)
  const { name } = data
  const nameRendered = typeof name === 'string' ? name : name && name[language.name] ? name[language.name] : JSON.stringify(name)

  return (
    <div>
      <Link to={data.link ? data.link : '#'} className="flex justify-between mb-1 items-center">
        <div className="text-xs mr-8">{nameRendered}</div>
        <div className={`text-xs font-semibold ${data.link ? 'underline' : ''}`}>{data.count}</div>
      </Link>
    </div>
  )
}

const MapPopupMetadataWithSubdata = ({ data }) => {
  const language = useSelector(state => state.system.language)
  const { name } = data
  const nameRendered = typeof name === 'string' ? name : name && name[language.name] ? name[language.name] : JSON.stringify(name)

  return (
    <div className="border-t border-solid pt-2 mb-2">
      <Link to={data.link ? data.link : '#'} className="flex justify-between mb-1 items-center">
        <div className="text-xs mr-8 font-semibold">{nameRendered}</div>
        <div className={`text-xs font-semibold ${data.link ? 'underline' : ''}`}>{data.count}</div>
      </Link>
      {data.subData.map((v, i) => (
        <Link to={v.link ? v.link : '#'} key={i} className="flex justify-between mb-1 ml-2 items-center">
          <div className="text-xs mr-8">{v.name}</div>
          <div className={`text-xs ${v.link ? 'underline' : ''}`}>{v.count}</div>
        </Link>
      ))}
    </div>
  )
}

const MapPopup = ({ data, onMouseOver, onMouseOut }) => {
  const { isMobile } = useViewport()
  const language = useSelector(state => state.system.language)
  const { name, content, address, coordinate } = data;
  const nameRendered = typeof name === 'string' ? name : name && name[language.name] ? name[language.name] : JSON.stringify(name)
  const contentRendered = typeof content === 'string' ? content : content && content[language.name] ? content[language.name] : undefined
  const contentTrimmed = contentRendered?.length > 600 ? excerptTrimmer(contentRendered, 600) : contentRendered
  const maxWidth = contentTrimmed?.length > 500 ? '375px' : '200px'
  const maxHeight = isMobile ? '130px' : 'initial'

  const onHover = () => {
    // setIsOpen(true)
    onMouseOver(data)
  }

  const onHoverOut = () => {
    // setIsOpen(false)
    onMouseOut(data)
  }

  return (
    <InfoWindow
      position={coordinate}
      options={{
        pixelOffset: new window.google.maps.Size(0, -20),
      }}
    >
      <div
        style={{ maxWidth, maxHeight }}
        className="text-black font-primary overflow-y-auto"
        onMouseOver={onHover}
        onMouseOut={onHoverOut}
      >
        <Link
          to={data.link ? data.link : "#"}
          className="flex justify-between mb-2 items-center"
        >
          <span className="block font-bold font-accent uppercase mr-8 text-base">
            {nameRendered}
          </span>
          <span
            className={`block text-xs font-semibold ${
              data.link ? "underline" : ""
            }`}
          >
            {data.total ? data.total : ""}
          </span>
        </Link>
        {data.metadata &&
          data.metadata.map((v, i) =>
            "subData" in v ? (
              <MapPopupMetadataWithSubdata data={v} key={i} />
            ) : (
              <MapPopupMetada data={v} key={i} />
            )
          )}
        {contentRendered && (
          <div
            className="text-xs"
            dangerouslySetInnerHTML={{ __html: contentTrimmed }}
          ></div>
        )}
        {address && coordinate && (
          <div className="mt-4">
            <a
              href={`https://maps.google.com/?q=${coordinate.lat},${coordinate.lng}`}
              className="text-xs underline text-gray-666 flex items-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="inline-block mr-2">{address}</span>
              <ExternalLink classname="inline-block" width={14} height={14} />
            </a>
          </div>
        )}
        {!data.metadata && data.link && (
          <div className="mt-4">
            <Link
              to={data.link}
              className="text-xs underline font-semibold text-primary"
            >
              View
            </Link>
          </div>
        )}
      </div>
    </InfoWindow>
  );
}

MapPopup.propTypes = {
  data: PropTypes.object.isRequired,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
}

MapPopup.defaultProps = {
  onMouseOver: () => {},
  onMouseOut: () => {},
}

export { MapPopup }
